function handleNavigate(event, navigate, link) {
    if (event?.ctrlKey) {        
        window.open(link, '_blank');
    } else {
        navigate(link);
    }
}

export default handleNavigate;